import { render, staticRenderFns } from "./customerlist.vue?vue&type=template&id=63699d14&scoped=true&"
import script from "./customerlist.vue?vue&type=script&lang=js&"
export * from "./customerlist.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./customerlist.vue?vue&type=style&index=1&id=63699d14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63699d14",
  null
  
)

export default component.exports